import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import AuthService from '../../../../../../services/auth.service';
import { createAppAsyncThunk } from '../../../../../../common/thunk';
import httpErrorHandling from '../../../../../../utils/httpErrorHandling';
import { SignupRequestAttributes } from '../../../../../../types/auth';

interface SignupState {
  email: string,
  waitingForCode: boolean,
  readyToLogin: boolean,
  error: string | null | undefined
}

export const signup = createAppAsyncThunk('auth/signup', async (attr: SignupRequestAttributes) => {
  return await AuthService.signup(attr).then(response => response.data);
})


const initialState: SignupState = {
  email: '',
  waitingForCode: false,
  readyToLogin: false,
  error: null
}
export const signupMainFormSlice = createSlice({
  name: 'signupMainForm',
  initialState,
  reducers: {
    saveEmail: (state, action: PayloadAction<string>) => {
      state.email = action.payload
    },
    flushRequestData: state => {
      state.waitingForCode = initialState.waitingForCode
      state.error = initialState.error
    }
  },
  extraReducers: (builder) => {
    builder.addCase(signup.fulfilled, (state, { payload }) => {
      const success = payload.status === 'email sent';
      state.waitingForCode = success;
      state.error = payload.error ? payload.error.message : !success ? payload.status : null;
    })
    builder.addCase(signup.rejected, (state, action) => {
      state.waitingForCode = false;
      state.error = httpErrorHandling(action);
    })
    builder.addCase(signup.pending, state => {
      state.error = '';
    })
  }
})
export const { saveEmail, flushRequestData } = signupMainFormSlice.actions;

export default signupMainFormSlice.reducer